import { Component } from '@theme/component';
import { fetchConfig, debounce, onAnimationEnd, prefersReducedMotion, resetShimmer } from '@theme/utilities';
import { CartAddEvent } from '@theme/events';
import { cartPerformance } from '@theme/performance';

/** @typedef {import('./utilities').TextComponent} TextComponent */

/**
 * A custom element that displays a cart items component.
 *
 * @typedef {object} Refs
 * @property {HTMLElement[]} quantitySelectors - The quantity selector elements.
 * @property {HTMLTableRowElement[]} cartItemRows - The cart item rows.
 * @property {TextComponent} cartTotal - The cart total.
 *
 * @extends {Component<Refs>}
 */
class CartSellingPlan extends Component{
    constructor() {
        super();
    }

    connectedCallback() {
        this.sellingPlanCheckbox = this.querySelector('.cart-items__subscribe-phurcase');
        if(!this.sellingPlanCheckbox) return;
        this.sellingPlanCheckbox.addEventListener('change', this.onChangeSellingPlan.bind(this));
    }

    async onChangeSellingPlan(e) {
        e.preventDefault();
        const isSubscription = this.sellingPlanCheckbox?.checked;
        const planId = this.sellingPlanCheckbox?.dataset.planId;
        const key = this.sellingPlanCheckbox?.dataset.key;
        const variantId = this.sellingPlanCheckbox?.dataset.id;
        const quantity = this.sellingPlanCheckbox?.dataset.quantity;
        const properties = JSON.parse(String(this.dataset.properties || '{}'));

        if(!key || !variantId || !quantity) return;

        const body = JSON.stringify({
            updates: { [key]: 0 }
        });
        await fetch(`${Theme.routes.cart_update_url}`, fetchConfig('json', { body }));

        const cartItemsComponents = document.querySelectorAll('cart-items-component');
        const sectionIds = [...cartItemsComponents]
            .filter(el => el instanceof HTMLElement && el.dataset.sectionId)
            .map(el => el.dataset.sectionId);
        const data = {
            id: variantId,
            quantity: quantity,
            selling_plan: planId && isSubscription ? planId : "",
            properties: properties,
            sections: sectionIds.join(',')
        }

        const formData = new FormData();

        this.closest('.cart-items__table-row')?.querySelectorAll('text-component').forEach(textComponent => {
            textComponent.shimmer();
        });

        Object.entries(data).forEach(([key, value]) => {
            if (key === "properties" && typeof value === "object") {
                Object.entries(value).forEach(([propKey, propValue]) => {
                    formData.append(`properties[${propKey}]`, propValue);
                });
            } else {
                formData.append(key, value);
            }
        });

        const fetchCfg = fetchConfig('javascript', { body: formData } );

        fetch(Theme.routes.cart_add_url, {
            ...fetchCfg,
            headers: {
            ...fetchCfg.headers,
            Accept: 'text/html',
            },
        })
            .then((response) => response.json())
            .then((response) => {
            if (response.status) return; 
            this.dispatchEvent(
                new CartAddEvent({}, variantId.toString(), {
                    source: 'cart-item-selling-plan',
                    sections: response.sections,
                })
            );
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                // add more thing to do in here if needed.
                cartPerformance.measureFromEvent('add:user-action', e);
            });
    }
}

if (!customElements.get('cart-selling-plan')) {
  customElements.define('cart-selling-plan', CartSellingPlan);
}